/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text and writing tools — word and syllable counters, case conversion, find and replace, duplicate-line removal, sorting, readability checks, a word unscrambler and a typing speed test.`)
};

const es_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de texto y escritura — contadores de palabras y sílabas, conversión de mayúsculas y minúsculas, buscar y reemplazar, eliminación de líneas duplicadas, ordenación, comprobaciones de legibilidad, un desordenador de palabras y una prueba de velocidad de escritura.`)
};

const de_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text- und Schreibwerkzeuge — Wort- und Silbenzähler, Groß-/Kleinschreibung umwandeln, Suchen und Ersetzen, Entfernen doppelter Zeilen, Sortieren, Lesbarkeitsprüfungen, ein Wort-Entwirrer und ein Tipptempo-Test.`)
};

const nl_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst- en schrijftools — woord- en lettergreeptellers, hoofdletterconversie, zoeken en vervangen, dubbele regels verwijderen, sorteren, leesbaarheidscontroles, een woordontwarraar en een typesnelheidstest.`)
};

const fr_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils de texte et d’écriture — compteurs de mots et de syllabes, conversion de casse, rechercher et remplacer, suppression de lignes en double, tri, vérifications de lisibilité, un démêleur de mots et un test de vitesse de frappe.`)
};

const it_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti di testo e scrittura — contatori di parole e sillabe, conversione maiuscole/minuscole, trova e sostituisci, rimozione di righe duplicate, ordinamento, controlli di leggibilità, uno sciogli-parole e un test di velocità di digitazione.`)
};

const pt_br2_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de texto e escrita — contadores de palavras e sílabas, conversão de maiúsculas/minúsculas, localizar e substituir, remoção de linhas duplicadas, ordenação, verificações de legibilidade, um desembaralhador de palavras e um teste de velocidade de digitação.`)
};

const pt_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de texto e escrita — contadores de palavras e sílabas, conversão de maiúsculas/minúsculas, localizar e substituir, remoção de linhas duplicadas, ordenação, verificações de legibilidade, um desembaralhador de palavras e um teste de velocidade de digitação.`)
};

const ja_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト・執筆ツール — 単語・音節カウンター、大文字小文字変換、検索と置換、重複行削除、並べ替え、読みやすさチェック、単語アンスクランブラー、タイピング速度テスト。`)
};

const zh_about_cat_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本与写作工具 — 单词与音节计数器、大小写转换、查找替换、删除重复行、排序、可读性检查、单词解谜工具以及打字速度测试。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_cat_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_cat_text(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_cat_text", locale)
	if (locale === "en") return en_about_cat_text(inputs)
	if (locale === "es") return es_about_cat_text(inputs)
	if (locale === "de") return de_about_cat_text(inputs)
	if (locale === "nl") return nl_about_cat_text(inputs)
	if (locale === "fr") return fr_about_cat_text(inputs)
	if (locale === "it") return it_about_cat_text(inputs)
	if (locale === "pt-BR") return pt_br2_about_cat_text(inputs)
	if (locale === "pt") return pt_about_cat_text(inputs)
	if (locale === "ja") return ja_about_cat_text(inputs)
	return zh_about_cat_text(inputs)
};